import { render, staticRenderFns } from "./viewApplication.vue?vue&type=template&id=f5134fb2&"
import script from "./viewApplication.vue?vue&type=script&lang=js&"
export * from "./viewApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports